<div class="layout-topbar bg-surface-0 dark:bg-surface-900">
  <div class="layout-topbar-logo-container">
    <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars dark:text-surface-0"></i>
    </button>
    <a class="layout-topbar-logo ml-4" routerLink="/">
      <img ngSrc="/img/logo-forma.png" priority width="28" height="30" [alt]="'topbar.brand' | translate" />
      <span class="text-lg md:text-xl dark:text-surface-0">{{ 'topbar.brand' | translate }}</span>
    </a>
  </div>
  <div class="layout-topbar-actions">
    <div class="layout-config-menu">
      <div class="relative">
        <button
          class="layout-topbar-action layout-topbar-action-highlight"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeout"
          [hideOnOutsideClick]="true"
        >
          <i class="pi pi-user"></i>
        </button>
        <rb-profile />
      </div>
    </div>
  </div>
</div>
